<script lang="ts" >
    import type { AdvancementStep } from "./step";

    export let steps: AdvancementStep[] = [];

</script>


<div class="wrapper">
    <ul>
        {#each steps as step }
            <li class="item" class:done={step.done} class:active={step.active} >
                { step.title }
            </li>    
        {/each}
    </ul>
</div>

<style>
    .wrapper {
        width: 330px;
    }
    .wrapper ul {
        position: relative;
        padding-left: 45px;
        list-style: none;
    }
    .wrapper ul::before {
        display: inline-block;
        content: "";
        position: absolute;
        top: 0;
        left: 15px;
        width: 10px;
        height: 100%;
        border-left: 2px solid #ccc;
    }
    .item {
        position: relative;
        counter-increment: list;
    }
    .item:not(:last-child) {
        padding-bottom: 20px;
    }
    .item::before {
        display: inline-block;
        position: absolute;
        left: -30px;
        height: 100%;
        width: 10px;
    }
    .item::after {
        content: counter(list);
        display: inline-block;
        position: absolute;
        padding-top: 1px;
        font-size: 14px;
        top: -4px;
        left: -40px;
        width: 19px;
        height: 18px;
        text-align: center;
        border: 2px solid #ccc;
        border-radius: 50%;
        background-color: #fff;
    }
    .item.done::before, .item.active::before {
        border-left: 2px solid;
    }
    .item.done::after, .item.active::after {
        border: 2px solid var(--primary-color);
    }
    .item.done::after {
        color: var(--primary-text-color);
        background-color: var(--primary-color);
    }
    .item.active::after {
        color: var(--primary-back-color);
        background-color: var(--primary-contrast);
    }
    .item.active {
        font-weight: bold;
    }
</style>
